import type { RequestStatusT } from '../domain/types/requestStatus.types';
import type { VacationRequestEntityT } from "../domain/entities/vacationRequest.entity";

import { REQUEST_STATUS } from "../constants/status";
import { VACATION_REQUESTS_STRINGS } from "../constants/strings";

type AuditHistoryEntryT = NonNullable<
  VacationRequestEntityT["audit"]
>["history"][number];

export const getProcessedByLabel = (status: RequestStatusT) => {
  switch (status) {
    case REQUEST_STATUS.APPROVED:
      return "Aprobada por:";
    case REQUEST_STATUS.APPLIED:
      return "Aplicada por:";
    case REQUEST_STATUS.PENDING:
      return "Pendiente por:";
    case REQUEST_STATUS.REJECTED:
      return "Rechazada por:";
    case REQUEST_STATUS.CANCELLED:
      return "Cancelada por:";
    default:
      return null;
  }
};

export const sortAuditHistoryAsc = (
  history?: AuditHistoryEntryT[] | null,
): AuditHistoryEntryT[] =>
  [...(history ?? [])].sort(
    (a, b) =>
      new Date(a.changedDate).getTime() - new Date(b.changedDate).getTime(),
  );

export const getProcessedBy = (
  request: Pick<VacationRequestEntityT, "status" | "leader" | "audit">,
): string | null => {
  if (request.status === REQUEST_STATUS.PENDING) {
    return request.leader?.name ?? VACATION_REQUESTS_STRINGS.HUMAN_RESOURCES_LABEL;
  }

  return sortAuditHistoryAsc(request.audit?.history).at(-1)?.changedByName ?? null;
};

export const mapOutUpdatedRequests = (
  oldData: VacationRequestEntityT[],
  succeededItems: VacationRequestEntityT[],
): VacationRequestEntityT[] => {
  const succeededMap = new Map(succeededItems.map((item) => [item.id, item]));

  return oldData.map((request) => {
    const updated = succeededMap.get(request.id);

    if (!updated) return request;

    return {
      ...request,
      status: REQUEST_STATUS[updated.status] ?? updated.status,
      processedBy: getProcessedBy(updated),
      audit: updated.audit ?? request.audit,
    };
  });
};

export const mapAppliedRequests = (
  oldData: VacationRequestEntityT[],
  appliedRequestIds: string[],
): VacationRequestEntityT[] => {
  const appliedSet = new Set(appliedRequestIds);

  return oldData.map((request) =>
    appliedSet.has(request.id)
      ? { ...request, status: REQUEST_STATUS.APPLIED }
      : request,
  );
};
